import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import ExtraServicesItem from "./ExtraServicesItemMobile";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import Button from "../Button";

// Rebranding 2026 · bordo dorato 5px sui servizi extra selezionati, radius coerente
const useStyles = makeStyles(() => ({
  pricingTable: {
    padding: "3%",
    background: "#fff",
    borderRadius: "14px",
    border: "1px solid #E8E6E0",
    boxShadow: "0 2px 8px rgba(31,33,37,0.06)",
    margin: "10px 0",
  },
  item: {
    margin: "8px 0",
    borderRadius: "12px",
    border: "5px solid transparent",
    transition: "border-color 200ms ease, background-color 200ms ease",
  },
  header: {
    marginBottom: "24px",
  },
  selected: {
    margin: "8px 0",
    borderRadius: "12px",
    border: "5px solid #C9A961",
    background: "#FAF4E6",
    boxShadow: "0 4px 12px rgba(201,169,97,0.22)",
  },
}));

export default function ExtraServiceMobile(props) {
  const classes = useStyles();
  const {
    selectedExtraServices,
    onSelectExtraService,
    extraservice,
    onClearSelection,
    initialExtraServices,
  } = props;

  const {
    title,
    subtitle,
    description,
    extraservices,
    closureText,
    isNew,
  } = extraservice;

  const groupName = title + subtitle;
  //Controllo se il groupo ha almeno un servizio che è stato selezionato
  const hasAtLeastOneItemSelected = extraservices
    .map((x) => x.value)
    .some((item) => selectedExtraServices.map((y) => y.value).includes(item));
  return (
    <div key={groupName} className={clsx(classes.pricingTable, "v-divider")}>
      <div className={classes.header}>
        <Typography variant="h6">{title}</Typography>
        <Typography variat="body">{description}</Typography>
      </div>
      {isNew && hasAtLeastOneItemSelected && onClearSelection && (
        <ContainedButton
          text="Annulla selezione"
          onClick={() => onClearSelection(groupName)}
        />
      )}
      <div>
        {extraservices.length > 0
          ? extraservices.map((xs) => {
              // Rebranding 2026 · usa lo stato CORRENTE (selectedExtraServices) per
              // applicare classes.selected. Funziona sia in Modifica Pacchetto
              // (OneStepForm, no initialExtraServices) sia in Personalizza esperienza
              // (UpsellingPackageDetails).
              const isCurrentlySelected = (selectedExtraServices || [])
                .map((y) => y.value)
                .includes(xs.value);
              const cl = isCurrentlySelected ? classes.selected : classes.item;
              return (
                <div className={cl} key={xs.value}>
                  <ExtraServicesItem
                    data={xs}
                    siblingNumber={extraservices.length - 1}
                    selectedExtraServices={selectedExtraServices}
                    onSelectExtraService={onSelectExtraService}
                  />
                </div>
              );
            })
          : null}
      </div>
      {!!closureText && (
        <div>
          <footer
            className="extra-closure-text"
            dangerouslySetInnerHTML={{
              __html: closureText,
            }}
          />
        </div>
      )}
    </div>
  );
}

ExtraServiceMobile.propTypes = {
  extraservice: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    closureText: PropTypes.string,
    extraservices: PropTypes.array,
    isNew: PropTypes.bool,
  }).isRequired,
  selectedExtraServices: PropTypes.array.isRequired,
  initialExtraServices: PropTypes.array,
  onSelectExtraService: PropTypes.func.isRequired,
};

const ContainedButton = styled(Button).attrs({
  variant: "contained",
  color: "primary",
})`
  color: white;
`;
